// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"UserRemovedModal_modalContainer__33i_I","headerText":"UserRemovedModal_headerText__24c25"};